import "core-js/modules/es6.array.map";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import Text from '../../../Atoms/Text/Text';
import BurgerMenu from '../Burger/BurgerMenu';
import { sizes } from '../../../../theme/shared/breakpoint';
import NavHelper from '../../../../utils/navHelper';
import InternalLinkHelper from '../../../../utils/internalLinkHelper';
import { Nav, NavMenu, NavItem, NavLink, SubNavMenu, SubNavItem, SubNavLink, SubNavLinkUnderline } from './Nav.style';

var MainNav = function MainNav(_ref) {
  var navItems = _ref.navItems;
  var menuGroups = navItems.menuGroups;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpandable = _useState2[0],
      setIsExpandable = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      isSubMenuOpen = _useState4[0],
      setIsSubMenuOpen = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      isKeyPressed = _useState6[0],
      setIsKeyPressed = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMobile = _useState8[0],
      setIsMobile = _useState8[1];

  var width = typeof window !== 'undefined' ? window.innerWidth : null;
  useEffect(function () {
    // Detect window screen size
    setIsMobile(width < sizes.medium);
  }, [width]);

  var toggleBurgerMenu = function toggleBurgerMenu(event) {
    event.preventDefault();
    setIsExpandable(!isExpandable);
  };

  var toggleSubMenu = function toggleSubMenu(item) {
    return function (event) {
      if (isMobile) {
        event.preventDefault();
        setIsSubMenuOpen(_defineProperty({}, item, !isSubMenuOpen[item]));
      }
    };
  }; // Handle tab key on menu nav


  var keyPressed = function keyPressed(item) {
    return function () {
      window.onkeyup = function (e) {
        if (e.target.querySelector('span') && e.target.querySelector('span').innerText === item) {
          setIsKeyPressed(_defineProperty({}, item, !isKeyPressed[item]));
        } else if (!e.target.querySelector('span')) {
          setIsKeyPressed({});
        }
      };
    };
  };

  useEffect(function () {
    window.addEventListener('onkeyup', setIsKeyPressed);
    return function () {
      window.removeEventListener('onkeyup', setIsKeyPressed);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Nav, {
    "aria-labelledby": "main-menu",
    isExpandable: isExpandable,
    role: "navigation"
  }, React.createElement(Text, {
    id: "main-menu",
    tag: "h2"
  }, "Main navigation"), React.createElement(NavMenu, {
    role: "menubar"
  }, menuGroups.map(function (group, index) {
    /* Grab the first links properties to use for our parent/button */
    var thisFirstChild = group.links[0];
    /* Determine which field represents our url path */

    var thisUrl = NavHelper(thisFirstChild);
    thisUrl = InternalLinkHelper(thisUrl);
    return React.createElement(NavItem, {
      role: "none",
      key: group.id,
      index: index,
      isSubMenuOpen: !!isSubMenuOpen[group.id]
    }, !isMobile ? React.createElement(NavLink, {
      href: thisUrl,
      inline: true,
      "aria-haspopup": "true",
      onClick: toggleSubMenu(group.id),
      onKeyUp: keyPressed(group.title)
    }, React.createElement(Text, null, thisFirstChild.title)) : React.createElement(NavLink, {
      href: thisUrl,
      inline: true,
      "aria-expanded": !!isSubMenuOpen[group.id],
      "aria-haspopup": "true",
      onClick: group.links && group.links.length > 1 && toggleSubMenu(group.id),
      onKeyUp: keyPressed(group.title),
      role: "button"
    }, React.createElement(Text, null, thisFirstChild.title)), group.links && group.links.length > 1 && React.createElement(SubNavMenu, {
      role: "list",
      isKeyPressed: !!isKeyPressed[group.title],
      isSubMenuOpen: !!isSubMenuOpen[group.id]
    }, group.links.map(function (child, childIndex) {
      var thisSubUrl = NavHelper(child);
      thisSubUrl = InternalLinkHelper(thisSubUrl);
      /* Wrap our first child item with special tags */

      if (childIndex === 0) {
        return React.createElement(SubNavItem, {
          role: "none",
          key: thisSubUrl
        }, React.createElement(SubNavLinkUnderline, {
          href: thisSubUrl,
          inline: true,
          role: "menuitem"
        }, React.createElement(Text, null, child.title)));
      }

      return React.createElement(SubNavItem, {
        key: thisSubUrl
      }, React.createElement(SubNavLink, {
        href: thisSubUrl,
        inline: true,
        role: "menuitem"
      }, React.createElement(Text, null, child.title)));
    })));
  }))), React.createElement(BurgerMenu, {
    toggle: toggleBurgerMenu,
    isExpandable: isExpandable
  }, "Open"));
};

MainNav.defaultProps = {
  navItems: {}
};
export default MainNav;